// client/src/components/Insights/shared/constants.js
export const GRADIENT = 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a78bfa 100%)';
export const GRADIENT_WARM = 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)';
export const GRADIENT_SUCCESS = 'linear-gradient(135deg, #10b981 0%, #06d6a0 100%)';
export const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
export const CATEGORY_COLORS = ['#8b5cf6','#3b82f6','#10b981','#f59e0b','#ef4444','#06b6d4','#ec4899','#84cc16','#f97316','#6366f1'];

export const alpha = (hex, opacity) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${opacity})`;
};

export const gradientTextSx = {
  background: 'linear-gradient(135deg, #6366f1, #a78bfa)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

export const SUGGESTED_QUESTIONS = [
  { cat: '💰', q: "What spending habit is costing me the most?" },
  { cat: '💰', q: "Which subscriptions should I cancel?" },
  { cat: '🎯', q: "Am I saving enough for retirement?" },
  { cat: '🎯', q: "How fast can I build an emergency fund?" },
  { cat: '🔮', q: "If I save more per month, when can I retire?" },
  { cat: '🔮', q: "What if I cut dining by 50%?" },
  { cat: '📊', q: "How is my financial health overall?" },
  { cat: '📊', q: "What's my worst financial habit?" },
];

export const GOAL_TEMPLATES = [
  { name: 'Emergency Fund', emoji: '🛡️', target: 5000 },
  { name: 'Dream Vacation', emoji: '✈️', target: 3000 },
  { name: 'House Down Payment', emoji: '🏠', target: 50000 },
  { name: 'New Car', emoji: '🚗', target: 15000 },
  { name: 'Investment Seed', emoji: '📈', target: 10000 },
  { name: 'Education Fund', emoji: '🎓', target: 20000 },
  { name: 'Wedding', emoji: '💍', target: 25000 },
  { name: 'Retirement Boost', emoji: '🌴', target: 100000 },
];
